import { types } from 'mobx-state-tree';
import { SITE_NAME } from '../constants';

const DEFAULT_TEXT = SITE_NAME;
const DEFAULT_PATH = '/';

const LogoStore = types
  .model('Logo', {
    text: types.optional(types.string, DEFAULT_TEXT),
    path: types.optional(types.string, DEFAULT_PATH),
  })
  .actions(self => ({
    setText(text) {
      self.text = text;
    },

    setPath(path) {
      self.path = path;
    },

    resetToDefaults() {
      self.text = DEFAULT_TEXT;
      self.path = DEFAULT_PATH;
    },
  }));

export default LogoStore;



// WEBPACK FOOTER //
// ./src/stores/LogoStore.js